import { skipToken, useQuery } from '@tanstack/react-query';

import type { SkuRuleRun } from '@nucleus-commerce/api-client/admin';

import { skuRulesApi } from '../api/sku-rules-api';

import { dictionaryKeys } from './dictionary-keys';

const POLL_MS = 2_000;

export const isRunFinished = (run: SkuRuleRun) => run.status === 'done' || run.status === 'failed';

/**
 * One apply run, polled every 2 s until it is done or failed. The interval callback stays pure:
 * TanStack Query evaluates it while rendering.
 */
export function useSkuRuleRun(ruleId: string, runId: string | null) {
  return useQuery({
    queryKey: runId
      ? dictionaryKeys.skuRuleRun(ruleId, runId)
      : dictionaryKeys.skuRuleRun(ruleId, ''),
    queryFn: runId ? () => skuRulesApi.getRun(ruleId, runId) : skipToken,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchInterval: (query) => {
      const run = query.state.data;
      return run && isRunFinished(run) ? false : POLL_MS;
    },
  });
}
